import { ReactNode, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// Composant de protection de route qui vérifie l'authentification et le rôle
interface ProtectedRouteProps {
  children: ReactNode;
  requiredRole?: string;
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Vérifier si l'utilisateur est connecté
    const accessToken = localStorage.getItem("accessToken");
    const userStr = localStorage.getItem("user");

    console.log("ProtectedRoute - Vérification d'authentification");
    console.log("Token existe:", !!accessToken);
    console.log("User data existe:", !!userStr);
    console.log("Rôle requis:", requiredRole);

    if (!accessToken || !userStr) {
      console.log("Authentification échouée: token ou user data manquant");
      setIsAuthorized(false);
      setIsLoading(false);
      return;
    }

    try {
      // Vérifier le rôle si nécessaire
      if (requiredRole) {
        const user = JSON.parse(userStr);
        const userRole = user.role?.toUpperCase() || "";
        const requiredRoleUpper = requiredRole.toUpperCase();

        console.log("Rôle utilisateur (normalisé):", userRole);
        console.log("Rôle requis (normalisé):", requiredRoleUpper);
        console.log(
          "Correspondance des rôles:",
          userRole === requiredRoleUpper
        );

        setIsAuthorized(userRole === requiredRoleUpper);
      } else {
        setIsAuthorized(true);
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du rôle:", error);
      setIsAuthorized(false);
    }

    setIsLoading(false);
  }, [requiredRole]);

  if (isLoading) {
    return <div className="p-8">Chargement...</div>;
  }

  console.log("Redirection finale - Autorisé:", isAuthorized);
  return isAuthorized ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
